export default __webpack_public_path__ + "static/media/0178.df0056e2.jpg";